
(function (window) {
  window.__env = window.__env || {};
  window.__env.Name = "#{name}";
  window.__env.Prod = "#{isProduction}";
  window.__env.BaseUrl = "#{baseURL}";  
}(this));